module.exports = __webpack_public_path__ + "static/media/holiday_help_map.f944d9f7.svg";